import {
  Typography,
  Box,
  Select,
  MenuItem,
  colors,
  useTheme,
} from "@mui/material";
import {
  IconButton,
  Menu,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import { useState, useEffect } from "react";
import {
  Delete,
  VisibilityOutlined,
  MoreVertRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import IconConstants from "../../utils/IconConstants";
import { errorToster, successToster } from "../../shared/toster/Toster";
import { END_POINT } from "../../utils/End-points";
import ApiClient from "../../apis/Api-client";
import { Helper } from "../../utils/Helpers";
import { format } from "date-fns";
import assetDefault from "../.././assets/icons/assetDefault.svg";
import { PermMenuItem } from "../../core/permissions";
const { formatDateTimeToDate, getGradientTextStyle } = new Helper();

// Helper function to handle null/undefined values

export const AssetType = ({ cell, onStatusChange, setAssetStatusChange }) => {
  const [previousStatus, setPreviousStatus] = useState("");

  const initialStatus = cell.getValue();
  const [selectedStatus, setSelectedStatus] = useState(initialStatus);
  useEffect(() => {
    setSelectedStatus(initialStatus);
  }, [initialStatus]);

  const statusStyles = {
    1: { bg: "#D9FFED", text: "#28A745", width: "90%", status: "Available" },
    2: { bg: "#D8EBFF", text: "#007BFF", width: "90%", status: "In use" },
    3: {
      bg: "#FFF9E8",
      text: "#D9A62E",
      width: "90%",
      status: "Under maintainance",
    }, // Correct key
    4: { bg: "#FFE7EC", text: "#DC3545", width: "90%", status: "Damaged" },
    5: { bg: "#EEEEEE", text: "#6C757D", width: "90%", status: "Disposed" },
  };

  const handleChange = (event) => {
    const newStatus = event.target.value;

    if (newStatus !== selectedStatus) {
      setAssetStatusChange(
        cell.row.original.asset_code,
        newStatus,
        window.scrollY
      );
    }
    setPreviousStatus(selectedStatus);

    // Update local and parent state immediately
    setSelectedStatus(newStatus);
    onStatusChange?.(newStatus);
  };

  const handleFormCancel = () => {
    // Revert to previous status
    setSelectedStatus(previousStatus);
    onStatusChange?.(previousStatus);
  };

  const handleFormSave = () => {
    // Handle form submission
    // Here you would typically send the data to your API
  };

  return (
    <>
      <Select
        value={selectedStatus}
        onChange={handleChange}
        autoFocus
        sx={{
          paddingX: "0.8vw",
          paddingY: "0.5vw",
          // width: statusStyles[selectedStatus]?.width,
          width: {
            xs: "25vw",
            sm: "22vw",
            md: "15vw",
            lg: "12vw",
          },

          borderRadius: "8px",
          backgroundColor: statusStyles[selectedStatus]?.bg,
          "& .MuiSelect-select": {
            padding: "0 !important",
            display: "flex !important",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.81vw !important",
            color: statusStyles[selectedStatus]?.text,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "rgb(255, 255, 255)",
          },
          "& .MuiMenuItem-root": {
            fontSize: "0.81vw",
          },
          ".MuiSvgIcon-root": {
            right: "2px",
            color: "#252525",
          },
        }}
        slotProps={{
          input: {
            sx: {
              // fontSize: { md: "0.8vw" },
            },
          },
        }}
        renderValue={(selected) => (
          <Typography
            sx={{
              fontSize: {
                xs: "1.9vw",
                sm: "1.5vw",
                md: "1.2vw",
                lg: "0.8vw",
              },
              mr: 2,
              color: statusStyles[selected]?.text,
            }}
          >
            {statusStyles[selected].status}
          </Typography>
        )}
      >
        {Object.keys(statusStyles)
          .filter((option) => option !== selectedStatus) // Exclude the currently selected option
          .map((option) => (
            <MenuItem
              key={option}
              value={option}
              sx={{
                "&& .MuiMenuItem-root": {
                  fontSize: "0.694vw !important",
                  height: "2.3vw",
                },
                "&:hover": { backgroundColor: statusStyles[option]?.bg },
                fontSize: "0.694vw",
                whiteSpace: "nowrap",
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  color: statusStyles[option]?.text,
                }}
              >
                {statusStyles[option].status}
              </Typography>
            </MenuItem>
          ))}
      </Select>

      {/* <Dialog
        open={showManagementForm}
        onClose={handleFormCancel}
        maxWidth="xs"
        fullWidth
        sx={{
          width: { xs: "30vw", sm: "24.514vw" },
          "& .MuiDialog-paper": {
            position: "absolute",
            top: "50%",
            left: "100%",
            transform: "translate(50%, -50%)",
            borderRadius: "12px",
            padding: "1.5vw",
          },
        }}
      >
        <DialogTitle
          sx={{ fontSize: "1.2vw", fontWeight: 600, padding: "0 0 1vw 0" }}
        >
          Under Maintenance
        </DialogTitle>
        <DialogContent sx={{ padding: "0 !important" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "1vw" }}>
            <TextField
              label="Technician Name"
              value={formData.technicianName}
              onChange={(e) =>
                // setFormData({ ...formData, technicianName: e.target.value })
              }
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: "2.5vw",
                  fontSize: "0.8vw",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.8vw",
                },
              }}
            />
            <TextField
              label="Contact Number"
              value={formData.contactNumber}
              onChange={(e) =>
                setFormData({ ...formData, contactNumber: e.target.value })
              }
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: "2.5vw",
                  fontSize: "0.8vw",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.8vw",
                },
              }}
            />
            <TextField
              label="Maintenance Type"
              value={formData.maintenanceType}
              onChange={(e) =>
                setFormData({ ...formData, maintenanceType: e.target.value })
              }
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: "2.5vw",
                  fontSize: "0.8vw",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.8vw",
                  fontWeight: 600,
                },
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            padding: "0",
            marginTop: "1vw",
            justifyContent: "space-around",
            display: "flex",
          }}
        >
          <Button
            fullWidth
            onClick={handleFormCancel}
            sx={{
              fontSize: "0.8vw",
              textTransform: "none",
              border: "1px solid #DAA72C",
              color: "#D9A62E",
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            onClick={handleFormSave}
            variant="contained"
            sx={{
              fontSize: "0.8vw",
              textTransform: "none",
              backgroundColor: "#D9A62E",
              color: "#fff",
              "&:hover": { backgroundColor: "##DAA72C" },
              padding: "0.5vw 1.5vw",
            }}
          >
            SAVE
          </Button>
        </DialogActions>
      </Dialog> */}
    </>
  );
};
const InfoRow = ({ label, value }) => (
  <>
    <Typography
      variant="body1"
      sx={{
        fontWeight: 400,
        fontSize: "14px",
        color: "#888888",
        marginRight: "8px",
        marginTop: "8px",
      }}
    >
      <strong>{label}:</strong>
    </Typography>
    <Typography
      variant="body2"
      sx={{
        fontWeight: 400,
        fontSize: "12px",
        color: value == "available" ? "green" : "#252525",
      }}
    >
      {value}
    </Typography>
  </>
);

export const ImageDisplay = (cell) => {
  let asset_image = cell.cell.row.original.asset_image ?? assetDefault;
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "4px",
      }}
    >
      <img
        src={asset_image}
        alt="Asset"
        style={{
          maxHeight: "30px",
          maxWidth: "100%",
          objectFit: "contain",
          borderRadius: "4px",
        }}
      />
    </Box>
  );
};
export const ActionCell = ({ row, editopen, setEditData, setRefresh }) => {
  const { api } = ApiClient();
  const { palette } = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewOpen, setViewOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();

  const formatValue = (value) => {
    return value || "-";
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleView = () => {
    setViewOpen(true);
    handleMenuClose();
  };

  const handleEditClick = () => {
    setEditData(row.original); // Pass the row data to parent
    editopen(true); // Pass the row data to parent
    setAnchorEl(null);
  };
  const handleDelete = () => {
    setDeleteOpen(true);
    handleMenuClose();
  };

  const confirmDelete = async () => {
    try {
      const data = {
        data: {
          asset_code: row.original.asset_code,
        },
      };

      // Send FormData to API
      const response = await api.delet(
        END_POINT.ASSET.DELETE_ASSET,
        "",
        data,
        "ERROR Deleting ASSET"
      );
      if (response.status === 200) {
        successToster("Asset deleted successfully!");
        setRefresh((prev) => !prev);
      } else {
        errorToster("Failed to delete asset");
      }
    } catch (error) {
      errorToster("Error deleting asset.");
    }
    setDeleteOpen(false);
  };

  const menuOptions = [
    {
      label: "View",
      permAction: "view",
      getIcon: (index) => (
        <Box
          sx={{
            width: { xs: "1.2rem", sm: "1.2rem", md: "1rem" },
            height: { xs: "1.2rem", sm: "1.2rem", md: "1rem" },
          }}
        >
          <img
            src={
              hoveredIndex === index
                ? IconConstants.ViewWhite
                : IconConstants.View
            }
            alt="view"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Box>
      ),
      onClick: handleView,
    },
    {
      label: "Edit",
      permAction: "update",
      getIcon: (index) => (
        <Box
          sx={{
            width: { xs: "1.2rem", sm: "1.2rem", md: "1rem" },
            height: { xs: "1.2rem", sm: "1.2rem", md: "1rem" },
          }}
        >
          <img
            src={
              hoveredIndex === index
                ? IconConstants.EditWhite
                : IconConstants.Edit
            }
            alt="edit"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Box>
      ),
      onClick: handleEditClick,
    },
    {
      label: "Delete",
      permAction: "delete",
      getIcon: (index) => (
        <Box
          sx={{
            width: { xs: "1.2rem", sm: "1.2rem", md: "1rem" },
            height: { xs: "1.2rem", sm: "1.2rem", md: "1rem" },
          }}
        >
          <img
            src={
              hoveredIndex === index
                ? IconConstants.DeleteIconWhite
                : IconConstants.GIDelete
            }
            alt="delete"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Box>
      ),
      onClick: handleDelete,
    },
  ];

  return (
    <>
      <IconButton
        size="small"
        sx={{
          background: Boolean(anchorEl)
            ? palette.tab.gradient
            : palette.primary.contrastText,
        }}
        onClick={handleMenuOpen}
      >
        <MoreVertRounded
          sx={{
            color: Boolean(anchorEl)
              ? palette.primary.contrastText
              : palette.icon.gradient,
          }}
          fontSize="small"
        />
      </IconButton>

      {/* Action Menu */}
      <Menu
        MenuListProps={{
          sx: {
            "& .MuiTypography-root": {
              fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.875rem" },
              fontWeight: 500,
            },
          },
        }}
        sx={{
          display: "flex",
          overflow: "auto",
        }}
        PaperProps={{
          sx: {
            px: 1,
            width: { xs: "12rem", sm: "12rem", md: "10rem" },
            maxHeight: "60vh",
            overflowY: "auto",
            borderRadius: "8px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
          },
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {menuOptions.map((option, index) => (
          <PermMenuItem
            action={option.permAction}
            key={option.label}
            onClick={option.onClick}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            sx={{
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
              justifyContent: "flex-start",
              borderRadius: 1.5,
              px: 1.5,
              py: 0.75,
              "&:hover": {
                background: palette.tab.gradient,
                "& .MuiListItemIcon-root, & .MuiListItemText-root": {
                  color: "white",
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: "auto", mr: 0 }}>
              {option.getIcon(index)}
            </ListItemIcon>
            <ListItemText
              sx={{
                ...(hoveredIndex === index
                  ? { color: palette.primary.contrastText }
                  : getGradientTextStyle(palette)),
              }}
            >
              {option.label}
            </ListItemText>
          </PermMenuItem>
        ))}
      </Menu>

      {/* View Dialog */}
      <Dialog
        open={viewOpen}
        onClose={() => setViewOpen(false)}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "20px",
            overflow: "hidden",
          },
        }}
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            {/* Top Section */}
            <Box
              sx={{
                display: "flex",
                gap: 3,
                pb: 2,
              }}
            >
              {/* Image Section (30%) */}
              <Box
                sx={{
                  width: "15.694vw",
                  borderRadius: "20px",
                  border: "1px solid #FFE097",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0px 4px 6px rgba(0, 0, 10, .1)",
                }}
              >
                <Box
                  sx={{
                    width: "14.375vw",
                    height: "11.667vw",
                  }}
                >
                  <img
                    src={row.original.asset_image}
                    alt="Asset"
                    style={{
                      width: "100%",
                      height: "150px",
                      objectFit: "fill",
                      borderRadius: "8px",
                    }}
                  />
                </Box>
              </Box>

              {/* Asset Information (70%) */}
              <Box
                sx={{
                  flex: 1,
                }}
              >
                <Typography
                  gutterBottom
                  sx={{
                    fontSize: {
                      xs: "16px",
                      sm: "18px",
                      md: "21px",
                      lg: "24px",
                    },
                    ...getGradientTextStyle(palette),
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Asset Information
                </Typography>

                {/* Asset Details Table */}
                <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Name
                        </TableCell>
                        <TableCell>
                          {formatValue(row.original.asset_name)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Asset Code
                        </TableCell>
                        <TableCell>
                          {formatValue(row.original.asset_code)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Status
                        </TableCell>
                        <TableCell>
                          {formatValue(row.original.status)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Location
                        </TableCell>
                        <TableCell>
                          {formatValue(row.original.location)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Category
                        </TableCell>
                        <TableCell>
                          {formatValue(row.original.category)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Brand
                        </TableCell>
                        <TableCell>{formatValue(row.original.brand)}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Model
                        </TableCell>
                        <TableCell>{formatValue(row.original.model)}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Description
                        </TableCell>
                        <TableCell>
                          {formatValue(row.original.description)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>

            {/* Bottom Section */}
            <Box
              sx={{
                display: "flex",
                gap: 3,
                justifyContent: "space-between",
              }}
            >
              {/* Purchase Information (50%) */}
              <Box sx={{ width: "50%" }}>
                <Typography
                  gutterBottom
                  sx={{
                    fontSize: {
                      xs: "16px",
                      sm: "18px",
                      md: "21px",
                      lg: "24px",
                    },
                    ...getGradientTextStyle(palette),
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Purchase Information
                </Typography>

                {/* Purchase Details Table */}
                <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Vendor
                        </TableCell>
                        <TableCell>
                          {formatValue(row.original.vendor_name)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          PO Number
                        </TableCell>
                        <TableCell>
                          {formatValue(row.original.po_number)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Invoice Number
                        </TableCell>
                        <TableCell>
                          {formatValue(row.original.invoice_number)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Price
                        </TableCell>
                        <TableCell>
                          {row.original.purchase_price
                            ? `₹${formatValue(row.original.purchase_price)}`
                            : "-"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Purchase Date
                        </TableCell>
                        <TableCell>
                          {formatValue(
                            formatDateTimeToDate(row.original.purchase_date)
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Invoice Date
                        </TableCell>
                        <TableCell>
                          {formatValue(
                            formatDateTimeToDate(row.original.invoice_date)
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Warranty Information (50%) */}
              <Box sx={{ width: "50%" }}>
                <Typography
                  gutterBottom
                  sx={{
                    fontSize: {
                      xs: "16px",
                      sm: "18px",
                      md: "21px",
                      lg: "24px",
                    },
                    ...getGradientTextStyle(palette),
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Warranty Information
                </Typography>

                {/* Warranty Details Table */}
                <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Warrenty Vendor
                        </TableCell>
                        <TableCell>
                          {formatValue(row.original.warrenty_vendor)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Warranty Start Date
                        </TableCell>
                        <TableCell>
                          {formatValue(
                            formatDateTimeToDate(
                              row.original.warrenty_start_date
                            )
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Warrenty End Date
                        </TableCell>
                        <TableCell>
                          {formatValue(
                            formatDateTimeToDate(row.original.warrenty_end_date)
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Insurance Start Date
                        </TableCell>
                        <TableCell>
                          {formatValue(
                            formatDateTimeToDate(
                              row.original.insurance_start_date
                            )
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 500, color: "#6F6F6F" }}>
                          Insurance End Date
                        </TableCell>
                        <TableCell>
                          {formatValue(
                            formatDateTimeToDate(
                              row.original.insurance_end_date
                            )
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>

            {/* Close Button */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
              }}
            >
              <Button onClick={() => setViewOpen(false)} variant="contained">
                Close
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Delete Confirmation */}
      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <DialogTitle sx={{ color: "#DEA829", fontWeight: 600 }}>
          Confirm Delete ?
        </DialogTitle>
        <DialogContent sx={{ color: "black", fontWeight: 400 }}>
          Are you sure you want to delete {row.original.asset_name}?
        </DialogContent>
        <DialogActions sx={{ mb: 3, justifyContent: "space-around" }}>
          <Button onClick={() => setDeleteOpen(false)} variant="contained">
            Cancel
          </Button>
          <Button onClick={confirmDelete} variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
